export { ClinicsList } from './ClinicsList';
export type { ClinicsListProps } from './ClinicsList';
